<section class="empty-state" [style.color]="color">
  <div class="icon-container">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="message-container">
    <p>{{ message }}</p>
  </div>
  <ng-content></ng-content>
</section>
